import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import { Button, Form, Modal } from "react-bootstrap";
import * as Yup from "yup";
import Step4 from "./Step4";
import AuthService from "../../services/AuthService";

//Images
import createImage from "../../assets/images/create.svg";
import signUpImage from "../../assets/images/signup.svg";
import checkImage from "../../assets/images/check.svg";
import Step5 from "./Step5";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import LogoImg from "../../assets/images/Main-Logo.png";
import HelmetBase from "../../components/HelmetBase";
import { useSelector } from "react-redux";

///

const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// const phoneRegExp =
//   /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

// const phnRegex = /^[0-9]{8,12}$/;
// const phnRegex = /^[0-9]{9}$/;
const phnRegex = /^5[0-9]{8}$/;

const SUPPORTED_FORMATS = ["image/jpeg", "image/png", "image/jpg"];

const Register = () => {
  const { t } = useTranslation();
  const { systemConfiguration } = useSelector((state) => state.commonStore);

  const stepComponents = [Step1, Step2, Step3, Step4, Step5];

  const steps = [
    t("Create Account"),
    t("National Address"),
    t("Merchant Information"),
    t("Bank Details"),
    t("Upload Image"),
  ];

  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);

  const handleClose = () => setShow(false);

  const CurrentStep = stepComponents[step];

  const isLastStep = step === steps.length - 1;

  const handleSubmit = async (values, actions) => {
    setLoading(true);
    await AuthService.register(values)
      .then((res) => {
        if (res?.data?.status == 1) {
          actions.setSubmitting(false);
          actions.resetForm();
          setShow(true);
          setLoading(false);
        } else {
          setLoading(false);
          actions.setSubmitting(false);
          actions.resetForm();
          setStep(0);
        }
      })
      .catch((error) => {
        setShow(false);
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  const goSignUp = () => {
    navigate("/login");
    setShow(false);
  };

  const validationSchema = [
    // Create Account
    Yup.object({
      fullName: Yup.string().required(t("Full name is required")).trim(),
      companyName: Yup.string().required(t("Company name is required")).trim(),
      email: Yup.string()
        .email(t("Please enter a valid email address"))
        .matches(emailRegex, t("Please enter a valid email address"))
        .required(t("Email is required"))
        .trim(),
      mobileNumber: Yup.string()
        .matches(phnRegex, t("Mobile number must be 9 digits and start with 5"))
        .required(t("Mobile number is required")),
      category: Yup.array()
        .min(1, t("Category is required"))
        .required(t("Category is required")),
      password: Yup.string()
        .min(8, t("Password must be atleast 8 characters"))
        .required(t("Password is required"))
        .trim(),
      confirmPassword: Yup.string()
        .required(t("Confirm password required"))
        .oneOf([Yup.ref("password"), null], t("Passwords must match"))
        .trim(),
    }),

    // Address Details
    Yup.object({
      // buildingNo: Yup.string().required(t("Building No. is required")).trim(),
      street: Yup.string().required(t("Street is required")).trim(),
      latitude: Yup.string().required(t("Latitude is required")).trim(),
      longitude: Yup.string().required(t("Longitude is required")).trim(),
      // secondaryNo: Yup.string().required(t("Secondary No. is required")).trim(),
      // district: Yup.string().required(t("District is required")).trim(),
      // postalCode: Yup.string().required(t("Postal Code is required")).trim(),
      // nationalAddress: Yup.string()
      //   .required(t("National Address is required"))
      //   .trim(),
      // short_address: Yup.string()
      //   .transform((value) => value?.toUpperCase())
      //   .trim()
      //   .required(t("Short Address is Required"))
      //   .matches(
      //     /^[A-Z]{4}[0-9]{4}$/,
      //     t("Short Address must be 4 letters followed by 4 numbers (e.g., RCTB4359)")
      //   ),
      nationalAdrressAttachment: Yup.mixed()
        .nullable()
      // .required(
      //   t("National Address Attachment is required")
      // ),
    }),

    // Merchant Information
    Yup.object({
      commercialRegistrationNumber: Yup.string()
        .required(t("Commercial Registration Number is required"))
        .trim(),
      taxIdentifictionNumber: Yup.string()
        .trim()
        .test(
          "len",
          t("Tax Identification Number must be 12 digits"),
          (val) => !val || val.length >= 12
        ),

      commercialRegistrationNumberAttachment: Yup.mixed()
        .nullable()
        .required(t("Commercial Registration Attachment is required")),
      taxIdentifictionNumberAttachment: Yup.mixed()
        .nullable()
      // .required(
      //   t("Tax Identification Attachment is required")
      // ),
    }),

    //Bank Info
    Yup.object({
      beneficiaryName: Yup.string()
        // .required(t("Beneficiary Name is required"))
        .trim(),
      bankName: Yup.string(),
      // .required(t("Bank Name is required")).trim(),
      // accountNumber: Yup.string()
      //   .min(9, t("Minimum 9 Digits Required"))
      //   .max(18, t("Maximun 18 Digits Required"))
      //   .required(t("Account Number is required"))
      //   .trim(),
      ibanNumber: Yup.string()
        .trim()
        .test(
          "iban-test",
          t("IBAN must start with SA and contain 22 digits"),
          (val) => !val || /^SA[0-9]{22}$/.test(val)
        ),
        // .required(t("IBAN Number is required")),
      ibanNumberAttachment: Yup.mixed()
        .nullable()
      // .required(
      //   t("IBAN Attachment is required")
      // ),
    }),

    // Logo and Banner
    Yup.object({
      logo: Yup.mixed()
        .nullable()
        .required(t("Logo image is required")),
      bannerImage: Yup.mixed()
        .nullable()
        .required(t("Banner image is required")),
    }),
  ];

  const initialValues = {
    fullName: "",
    companyName: "",
    email: "",
    mobileNumber: "",
    category: [],
    password: "",
    confirmPassword: "",

    buildingNo: "",
    street: "",
    latitude: "",
    longitude: "",
    secondaryNo: "",
    district: "",
    postalCode: "",
    short_address: "",
    nationalAddress: "",
    nationalAdrressAttachment: "",

    commercialRegistrationNumber: "",
    commercialRegistrationNumberAttachment: "",
    taxIdentifictionNumber: "",
    taxIdentifictionNumberAttachment: "",

    beneficiaryName: "",
    bankName: "",
    // accountNumber: "",
    ibanNumber: "",
    ibanNumberAttachment: "",

    logo: "",
    bannerImage: "",
  };


  return (
    <>
      <HelmetBase title={`${t("Sign Up")}`} name={`${t("Sign Up")}`} />
      <div className="container-fluid">
        <div className="row login-container">
          <div className="col-md-6 left-side">
            <img
              src={signUpImage}
              alt="Login Illustration"
              className="login-image"
            />
          </div>

          <div className="col-md-6 right-side">
            <div className="login-form">
              <div className="brand-logo d-flex justify-content-center mb-5">
                <Link to="/">
                  <img src={systemConfiguration?.logo} alt="" />
                </Link>
              </div>
              <div className="head-contant">
                <div className="head-image">
                  <img src={createImage} alt="" />
                </div>
                <div className="head-text">
                  <h1>{steps[step]}</h1>
                  {step == 0 && (
                    <p>
                      {t(
                        "Fill your information below or register with your social account."
                      )}
                    </p>
                  )}
                </div>
              </div>
              <Formik
                initialValues={initialValues}
                onSubmit={(values, actions) => handleSubmit(values, actions)}
                validationSchema={validationSchema[step]}
              >
                {(formik) => {
                  console.log("FORMIK VALUE", formik.values);

                  return (
                    <Form
                      onSubmit={formik.handleSubmit}
                      encType="multipart/form-data"
                    >
                      {!stepComponents[step] && (
                        <div>Error: Step component not found</div>
                      )}

                      {CurrentStep ? <CurrentStep /> : <div>No Data</div>}

                      <div className="d-flex gap-2 mt-3">
                        {step > 0 && (
                          <button
                            type="button"
                            className="btn btn-outline-secondary w-100"
                            onClick={() => setStep(step - 1)}
                            disabled={loading || formik.isSubmitting}
                          >
                            {t("Previous")}
                          </button>
                        )}

                        {isLastStep ? (
                          <button
                            type="submit"
                            className="btn btn-primary w-100"
                            disabled={loading}
                          >
                            {loading ? `${t("Loading...")}` : `${t("Submit")}`}
                          </button>
                        ) : (
                          <button
                            type={"button"}
                            className="btn btn-primary w-100"
                            disabled={formik.isSubmitting}
                            onClick={async () => {
                              const errors = await formik.validateForm();
                              const currentFields = Object.keys(
                                validationSchema[step].fields
                              );

                              const currentStepErrors = Object.keys(
                                errors
                              ).filter((key) => currentFields.includes(key));

                              if (currentStepErrors.length === 0) {
                                if (step == 0) {
                                  const obj = {
                                    email: formik?.values?.email,
                                    mobile_number: formik?.values?.mobileNumber,
                                  };
                                  await AuthService.checkEmailAndMobileNumber(
                                    obj
                                  ).then(async (res) => {
                                    if (res?.status == 1) {
                                      setStep(step + 1);
                                    }
                                  });
                                } else {
                                  setStep(step + 1);
                                }
                              } else {
                                const touched = {};
                                currentFields.forEach((field) => {
                                  touched[field] = true;
                                });
                                formik.setTouched({
                                  ...formik.touched,
                                  ...touched,
                                });
                              }
                            }}
                          >
                            {t("Next")}
                          </button>
                        )}
                      </div>
                      {/* {isLastStep ? (
                        <button type="submit" className="btn btn-primary w-100">
                          Submit
                        </button>
                      ) : (
                        <button
                          type="button"
                          onClick={() => setStep(step + 1)}
                          className="btn btn-primary w-100"
                        >
                          Next
                        </button>
                      )} */}
                      <p className="text-center mt-4">
                        {t("Already have an account?")}{" "}
                        <Link to="/login" className="text-decoration-none">
                          {t("Sign in")}
                        </Link>
                      </p>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        size="md"
        backdrop="static"
        centered
      >
        <Modal.Body>
          <div className="modal-icon">
            <img src={checkImage} alt="" />
          </div>
          <h2>{t("Registration submitted successfully!")}</h2>
          <p>
            {t(
              "Thank you for registering with Offary! Once your details are verified, one of our representatives will reach out within 2–3 working days."
            )}
          </p>
          <Button variant="primary" onClick={() => goSignUp()}>
            {t("Go To Sign in page")}
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Register;
